var shapeUpdateList = [['circle', 'cylinder'], ['square', 'cylinder'], ['triangle', 'cylinder'], ['pentagon', 'cylinder'], ['hexagon', 'cylinder'], ['octogon', 'cylinder'], ['hexagram', 'cylinder'], ['rhombus', 'cylinder'], ['vesica', 'cylinder']];
export function updateShape(layer, lastShape, currentShape) {
  if (typeof lastShape === 'string' && typeof currentShape === 'string' && lastShape !== currentShape) {
    if (layer.type === 'PointLayer') {
      layer.dataState.dataSourceNeedUpdate = true;
      return;
    }

    shapeUpdateList.map(function (shapes) {
      if (shapes.includes(lastShape) && shapes.includes(currentShape)) {
        layer.dataState.dataSourceNeedUpdate = true;
        return;
      }
    });
  }
}
//# sourceMappingURL=updateShape.js.map